import React from 'react';
import { StyleSheet, View, Platform, ActivityIndicator } from 'react-native';
import { Tile } from 'fitbeat.react-native-components';
import Theme from '../../theme';
export class TrackingLoadingTile extends React.PureComponent {
 render() {
        return (
            <View style={styles.mainContainer}>
                <Tile customStyle={styles.container}>
                    <ActivityIndicator
                        size="large"
                        animating={this.props.isLoading ? this.props.isLoading : true}
                        color={Theme.PRIMARY}
                        style={styles.activityIndicator}
                    />
                </Tile>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    mainContainer: {
        padding: 10
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: 8,
        backgroundColor: 'transparent',
        ...Platform.select({
            web: {
                paddingVertical: 0,
            },
        }),
    },
    activityIndicator: {
        padding: 20
    }
});
